module.exports = __webpack_public_path__ + "static/media/4.aebed2af.jpg";